import { _ } from "../../../../core/polyglot/polyglot.js";
import AbstractPeriodColumnTemplate from "./AbstractPeriodColumnTemplate.js";
import ClosingBalanceColumn from "../../reports/columns/ClosingBalanceColumn.js";

/**
 * Closing balance column template.
 */
export default class ClosingBalanceColumnTemplate extends AbstractPeriodColumnTemplate {
	accept(visitor) {
		return visitor.visitClosingBalanceColumnTemplate(this);
	}

	_instanceClass() {
		return ClosingBalanceColumn;
	}

	static getLabel() {
		return _("Closing balance");
	}

	static getType() {
		return "ClosingBalanceColumnTemplate";
	}
}
